import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import { Row, Col } from '@gympass/yoga'
import { Hidden } from '@material-ui/core'

import { moreInformation } from '@assets'
import { DownloadWhite } from '@assets/icons'

import useContact from '@hooks/useContact'
import useDataLayer from '@hooks/useDataLayer'
import useRouteBuilder from '@hooks/useRouteBuilder'
import useLoading from '@hooks/useLoading'

import InputButton from '@components/InputButton'

import { createContact } from '@store/ducks/simulate'

import { getCookie } from '@client/services/cookies'

import Container from '../../Home.style'
import * as Styles from './InformationGuide.style'

import useValidationSchema from './InformationGuide.validation'

export default function InformationGuide() {
  const FEATURE_TO_LOAD = 'InformationGuide'

  const intl = useIntl()
  const history = useHistory()
  const dispatch = useDispatch()
  const validationSchema = useValidationSchema()

  const { contact } = useContact()
  const { buildRoute } = useRouteBuilder()
  const { events, values } = useDataLayer()
  const { isLoading, startLoad, finishLoad, featureLoading } = useLoading()

  async function handleWorkEmail({ email }) {
    const hubspotutk = getCookie('hubspotutk')

    const data = {
      ...contact,
      token: hubspotutk,
      country: 'United States',
      gympassGuideDownloaded: true,
      email,
    }

    try {
      startLoad(FEATURE_TO_LOAD)

      await dispatch(createContact(data))

      window.open(
        'https://hs.gympass.com/hubfs/SMB_files/Gympass_introductory_guide.pdf'
      )

      events.simulatorInteraction(values.GYMPASS_GUIDE_DOWNLOAD)
    } catch (error) {
      if (error.response.status === 409) {
        history.push(buildRoute('/thank-you/already-eligible'))
      }
    } finally {
      finishLoad()
    }
  }

  return (
    <Styles.Main>
      <Container>
        <Row>
          <Col xxs={12} xl-start={2} xl={5}>
            <Styles.Title>
              <FormattedMessage
                id="smb_acquisition_home.information_guide.title"
                values={{
                  strong: (...chunks) => <strong>{chunks}</strong>,
                }}
              />
            </Styles.Title>

            <Styles.Subtitle>
              <FormattedMessage id="smb_acquisition_home.information_guide.subtitle" />
            </Styles.Subtitle>

            <Styles.ButtonWrapper>
              <InputButton
                name="email"
                loading={isLoading && featureLoading === FEATURE_TO_LOAD}
                validationSchema={validationSchema}
                onClick={handleWorkEmail}
                placeholder={intl.formatMessage({
                  id:
                    'smb_acquisition_home.information_guide.form.email.placeholder',
                })}
              >
                <Styles.ButtonTextWrapper>
                  <img src={DownloadWhite} alt="" />
                  <Styles.ButtonText>
                    <FormattedMessage id="smb_acquisition_home.information_guide.call_to_action.download" />
                  </Styles.ButtonText>
                </Styles.ButtonTextWrapper>
              </InputButton>
            </Styles.ButtonWrapper>
          </Col>

          <Hidden mdDown>
            <Col xl-start={8} xl={5}>
              <Styles.ImageWrapper
                src={moreInformation}
                alt="girl in a living room explaining something"
              />
            </Col>
          </Hidden>
        </Row>
      </Container>
    </Styles.Main>
  )
}
